export default __webpack_public_path__ + "static/media/Mark-4-Suit-05.2e7704d1.jpg";